import React, { useEffect, useRef, useState } from 'react';
import { Button, Table, Card, Tabs, Tab } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "@arcgis/core/assets/esri/themes/light/main.css";
import './Gis.css';
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";
import Circle from "@arcgis/core/geometry/Circle.js";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import PopupTemplate from "@arcgis/core/PopupTemplate.js";
import Color from "@arcgis/core/Color.js";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer.js";
import Basemap from "@arcgis/core/Basemap.js";
import Point from "@arcgis/core/geometry/Point.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Search from "@arcgis/core/widgets/Search.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import esriConfig from "@arcgis/core/config.js";
import esriRequest from "@arcgis/core/request.js";
import Graphic from "@arcgis/core/Graphic.js";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer.js";
import { identify } from "@arcgis/core/rest/identify";
import Directions from "@arcgis/core/widgets/Directions.js";
import RouteLayer from "@arcgis/core/layers/RouteLayer.js";
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'material-icons/iconfont/material-icons.css';
import NearMeIcon from '@mui/icons-material/NearMe';
import GisHeader from './Gis_Header';
import NearByRoute from './Gis_Nearbyroute';
import MeasureTool from './Gis_Measure';
import BufferTool from './Gis_Buffer';
import GisLayer from './Gis_Layerlist';
import Nearby from './Nearby';
import { useNavigate } from 'react-router-dom';
import config from './Config.json';
import source from './Source.json';
import Streets from '../../img/Basemap/nicStreetNew.png';
import satellite from '../../img/Basemap/satellite.png';
import NIC_Base from '../../img/Basemap/NIC_Base.png';
import NIC_Terrain from '../../img/Basemap/terrain.png';
import esri from '../../img/Basemap/esri_street.png';
import No_Base from '../../img/Basemap/india_bnd.png';
import Draggable from 'react-draggable';
import clear from './images/broom.png';
import extent from './images/extent.png';

// Global variables
var map;
var view;
var mskgraphicLayer;
var directionsWidget;
var higraphicLayer;
var zoomGraphicLayer;
var AoigraphicsLayer;
var specificAoiBankName;
var maskBufferredGeometry = null;
var basemapCollection = [];
var searchWidgetheader;
var allBankNameArray = [];
var bankwiseStatistic = [];
var statisticLayerNametble;
var selected_dtcode = '0', selected_stcode = '1000', selected_blkcode;
var layernameGlobal = [];
var StateStatistic = [];
var DistStatistic = [];
var count = 0;
var SpRef = [];
SpRef.wkid = 102100;
var stid = "";
var tabname = "";
var stname;

var list = [];
var array = [];
var totalPages = 0;

const recordsPerPage = 1000;

// Helper function to build query URL
const getQueryUrl = (baseUrl, layerId = '') => {
    const url = layerId ? `${baseUrl}/${layerId}` : baseUrl;
    return url + "?token=";
};

// State and District layer URLs from your services
const STATE_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/61";
const DISTRICT_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/62";

const Gis_Dash = () => {
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const [showDirections, setShowDirections] = useState(false);
  const directionsDiv = useRef(null);
  const directionRef = useRef(null);
  const [data, setData] = useState(config);
  const [mysource, setMysource] = useState(source);
  const [key, setKey] = useState('');
  const [mapview, setMapview] = useState();
  const [basemap, setBasemap] = useState("streets-vector");
  const [isBasemapVisible, setBasemapVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeCard, setActiveCard] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [isTableCardOpen, setIsTableCardOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [fields, setFields] = useState([]);
  const [resdata, setResdata] = useState([]);
  const [atmfields, setAtmFields] = useState([]);
  const [atmdata, setAtmResdata] = useState([]);
  const [mithrafields, setithraFields] = useState([]);
  const [mithradata, setMithraResdata] = useState([]);
  const [ippbfields, setippbFields] = useState([]);
  const [ippbdata, setippbResdata] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoading, setIsLoading] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [tabTitles, setTabTitles] = useState({
    bank: "Bank Branch",
    atm: "ATM",
    mithra: "Bank Mitra",
    ippb: "IPPB",
  });
  const [currentPages, setCurrentPages] = useState(1);

  var highlightpointSymbol = new SimpleMarkerSymbol(SimpleMarkerSymbol.STYLE_CIRCLE, 12,
    new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([192, 37, 146]), 3), new Color([255, 255, 0]));

  // Handle State Change
  const handleStateChange = (event) => {
    const simpleLineSymbol = {
      type: "simple-line",
      color: [255, 0, 0],
      width: 2,
      style: "solid"
    };

    const selectedState = event.target.value;
    selected_stcode = event.target.value;
    selected_dtcode = '0';

    if (AoigraphicsLayer) AoigraphicsLayer.graphics.removeAll();
    setKey('');
    setResdata([]);
    setAtmResdata([]);
    setMithraResdata([]);
    setippbResdata([]);
    setCurrentPages(1);
    setIsTableCardOpen(false);
    setIsLoading(true);

    if (selectedState === "") {
      stid = event.target.value;
      stname = event.target.options[event.target.selectedIndex]?.text || "";
      setState(selectedState);
      if (higraphicLayer) higraphicLayer.graphics.removeAll();
      if (mskgraphicLayer) mskgraphicLayer.graphics.removeAll();
      setIsLoading(false);
    } else {
      stid = event.target.value;
      stname = event.target.options[event.target.selectedIndex]?.text || "";
      setState(selectedState);
      if (higraphicLayer) higraphicLayer.graphics.removeAll();
      if (mskgraphicLayer) mskgraphicLayer.graphics.removeAll();

      // Execute all counts and state geometry query in parallel
      Promise.all([
        query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "5"), {
          where: "statelgd = " + stid
        }).then(BankCount).catch((error) => console.log("Bank Count Error:", error)),

        query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "6"), {
          where: "statelgd = " + stid
        }).then(AtmCount).catch((error) => console.log("ATM Count Error:", error)),

        query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "7"), {
          where: "statelgd = " + stid
        }).then(MithraCount).catch((error) => console.log("Mithra Count Error:", error)),

        query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "66"), {
          where: "statelgd = " + stid
        }).then(ippbCount).catch((error) => console.log("IPPB Count Error:", error)),

        // State geometry query - using state_lgd field
        query.executeQueryJSON(getQueryUrl(STATE_LAYER_URL), new Query({
          returnGeometry: true,
          where: "state_lgd = " + stid,
          outFields: ["*"],
          outSpatialReference: 3857
        })).catch(error => {
          console.error("State geometry query failed:", error);
          return { features: [] };
        })
      ]).then(([bankCount, atmCount, mithraCount, ippbCount, stateResponse]) => {
        if (stateResponse.features && stateResponse.features.length > 0) {
          _doMaskOperation(stateResponse.features[0].geometry);

          var current_geometry = stateResponse.features[0].geometry;
          
          view.goTo({
            target: stateResponse.features[0].geometry,
          });
          
          let highLightGraphics = new Graphic({
            geometry: current_geometry,
            symbol: simpleLineSymbol,
          });

          if (higraphicLayer) higraphicLayer.add(highLightGraphics);

          // Query districts for this state - using state_lgd field
          var dtparams = new Query({
            outFields: ["dist_lgd", "dtname"],
            where: "state_lgd = " + stid,
            outSpatialReference: 3857,
            orderByFields: ["dtname"]
          });

          query.executeQueryJSON(getQueryUrl(DISTRICT_LAYER_URL), dtparams)
            .then(getDistrictResults)
            .catch(error => {
              console.error("District query failed:", error);
              setOptions2([]);
            });
        } else {
          console.warn("No state geometry found for:", stid);
          setOptions2([]);
        }
      }).catch((error) => {
        console.error("Error in handleStateChange:", error);
      }).finally(() => {
        setIsLoading(false);
      });

      function getDistrictResults(response) {
        if (response && response.features && response.features.length > 0) {
          var distFeatures = response.features;
          var optionsArray = [];
          
          for (var i = 0; i < distFeatures.length; i++) {
            optionsArray.push({
              value: distFeatures[i].attributes["dist_lgd"],
              label: distFeatures[i].attributes["dtname"],
            });
          }
          
          console.log("District options:", optionsArray);
          setOptions2(optionsArray);
        } else {
          console.warn("No district features found");
          setOptions2([]);
        }
      }
    }
  };

  // Handle District Change
  const handleDistrictChange = (event) => {
    const simpleLineSymbol = {
      type: "simple-line",
      color: [255, 0, 0],
      width: 2,
      style: "solid"
    };

    if (AoigraphicsLayer) AoigraphicsLayer.graphics.removeAll();
    
    const selectedDistrict = event.target.value;
    selected_dtcode = event.target.value;
    
    setIsTableCardOpen(false);
    setKey('');
    setResdata([]);
    setAtmResdata([]);
    setMithraResdata([]);
    setippbResdata([]);
    setCurrentPages(1);
    setIsLoading(true);

    if (selectedDistrict === "") {
      setDistrict(selectedDistrict);
      setIsTableCardOpen(false);
      if (higraphicLayer) higraphicLayer.graphics.removeAll();
      if (mskgraphicLayer) mskgraphicLayer.graphics.removeAll();
      setIsLoading(false);
    } else {
      setDistrict(selectedDistrict);
      if (higraphicLayer) higraphicLayer.graphics.removeAll();
      if (mskgraphicLayer) mskgraphicLayer.graphics.removeAll();

      // Query district boundary using dist_lgd field
      const dtparam = new Query({
        returnGeometry: true,
        where: "dist_lgd = " + selectedDistrict,
        outFields: ["*"],
        outSpatialReference: 3857
      });

      query.executeQueryJSON(getQueryUrl(DISTRICT_LAYER_URL), dtparam)
        .then(function (response) {
          if (response.features && response.features.length > 0) {
            const districtFeature = response.features[0];
            const stateCode = districtFeature.attributes["state_lgd"];

            _doMaskOperation(districtFeature.geometry);

            return Promise.all([
              query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "5"), {
                where: "statelgd = " + stateCode + " and distlgd = " + selectedDistrict
              }).then(BankCount).catch((error) => console.log("Bank District Count Error:", error)),

              query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "6"), {
                where: "statelgd = " + stateCode + " and distlgd = " + selectedDistrict
              }).then(AtmCount).catch((error) => console.log("ATM District Count Error:", error)),

              query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "7"), {
                where: "statelgd = " + stateCode + " and distlgd = " + selectedDistrict
              }).then(MithraCount).catch((error) => console.log("Mithra District Count Error:", error)),

              query.executeForCount(getQueryUrl(data.layerForQuery.DataLayer[0].Url, "66"), {
                where: "statelgd = " + stateCode + " and distlgd = " + selectedDistrict
              }).then(ippbCount).catch((error) => console.log("IPPB District Count Error:", error)),

              Promise.resolve(districtFeature)
            ]);
          } else {
            throw new Error("No district features found");
          }
        })
        .then((results) => {
          if (results) {
            const districtFeature = results[4];
            const current_geometry = districtFeature.geometry;

            view.goTo({
              target: current_geometry,
              zoom: 10
            }, {
              duration: 800
            }).then(() => {
              const highLightGraphics = new Graphic({
                geometry: current_geometry,
                symbol: simpleLineSymbol,
              });
              if (higraphicLayer) higraphicLayer.add(highLightGraphics);
            }).catch((error) => {
              console.error("Error in view navigation:", error);
              const highLightGraphics = new Graphic({
                geometry: current_geometry,
                symbol: simpleLineSymbol,
              });
              if (higraphicLayer) higraphicLayer.add(highLightGraphics);
            });
          }
        })
        .catch((error) => {
          console.error("District query error:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  // Statistics functions
  function ShowStateStatistics(StateStatistic) {
    if (selected_dtcode !== '0') {
      updateTabTitle("bank", "Bank Branch(" + DistStatistic[0] + ")");
      updateTabTitle("atm", "ATM(" + DistStatistic[1] + ")");
      updateTabTitle("mithra", "Bank Mitra(" + DistStatistic[2] + ")");
      updateTabTitle("ippb", "IPPB(" + (DistStatistic[9] || 0) + ")");
    } else {
      updateTabTitle("bank", "Bank Branch(" + StateStatistic[0] + ")");
      updateTabTitle("atm", "ATM(" + StateStatistic[1] + ")");
      updateTabTitle("mithra", "Bank Mitra(" + StateStatistic[2] + ")");
      updateTabTitle("ippb", "IPPB(" + (StateStatistic[9] || 0) + ")");
    }
  }

  function BankCount(count) {
    console.log(count, " features matched the input Bank Branch");
    var BBstat = count;
    StateStatistic[0] = BBstat;
    DistStatistic[0] = BBstat;
    setTimeout(function () { ShowStateStatistics(StateStatistic); }, 2000);
    setIsTableCardOpen(true);
  }

  function AtmCount(count) {
    console.log(count, " features matched the input ATM");
    var ATMstat = count;
    StateStatistic[1] = ATMstat;
    DistStatistic[1] = ATMstat;
  }

  function ippbCount(count) {
    console.log(count, " features matched the input IPPB");
    var ippbstat = count;
    StateStatistic[9] = ippbstat;
    DistStatistic[9] = ippbstat;
  }

  function MithraCount(count) {
    console.log(count, " features matched the input Mithra");
    var BMstat = count;
    StateStatistic[2] = BMstat;
    DistStatistic[2] = BMstat;
  }

  const showbanktbl = () => {
    tabname = "bank";
    bankBranchStatistics();
  };

  const showAtmtbl = () => {
    atmStatistics();
  };

  const showmithratbl = () => {
    bankMitraStatistics();
  };

  const showippbtbl = () => {
    ippbStatistics();
  };

  var staticticLayerId;

  function ippbStatistics() {
    console.log('IPPB Statistics');
    staticticLayerId = "66";
    statisticLayerNametble = "IPPB";
    var counts;
    getBankNames(staticticLayerId);

    if (selected_dtcode != '0') {
      counts = DistStatistic[9];
      console.log("District IPPB Count:", counts);

      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode + " and distlgd = " + selected_dtcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            console.log("IPPB District Object IDs:", resultLen);
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                districtStatisticMThousand(result);
              } else {
                districtStatisticLThousand();
              }
            } else {
              districtStatisticLThousand();
            }
          })
          .catch(error => {
            console.error("Error in IPPB district query:", error);
            districtStatisticLThousand();
          });
      } else {
        districtStatisticLThousand();
      }
    } else if (selected_stcode != '1000' && selected_dtcode == '0') {
      counts = StateStatistic[9];
      console.log("State IPPB Count:", counts);

      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            console.log("IPPB State Object IDs:", resultLen);
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                stateStatisticMThousand(result);
              } else {
                stateStatisticLThousand();
              }
            } else {
              stateStatisticLThousand();
            }
          })
          .catch(error => {
            console.error("Error in IPPB state query:", error);
            stateStatisticLThousand();
          });
      } else {
        stateStatisticLThousand();
      }
    } else {
      console.log("National level IPPB query - not implemented");
    }
  }

  function bankBranchStatistics() {
    console.log('BB');
    staticticLayerId = data.layerForQuery.DataLayer[0].infotemplates[0].id;
    statisticLayerNametble = "Bank Branch";
    var counts;
    getBankNames(staticticLayerId);
    
    if (selected_dtcode != '0') {
      counts = DistStatistic[0];
      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode + " and distlgd = " + selected_dtcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, data.layerForQuery.DataLayer[0].infotemplates[0].id), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                districtStatisticMThousand(result);
              }
            }
          });
      } else {
        districtStatisticLThousand();
      }
    } else if (selected_stcode != '1000' && selected_dtcode == '0') {
      counts = StateStatistic[0];
      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, data.layerForQuery.DataLayer[0].infotemplates[0].id), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                stateStatisticMThousand(result);
              }
            }
          });
      } else {
        stateStatisticLThousand();
      }
    }
  }

  function atmStatistics() {
    console.log('atm');
    staticticLayerId = data.layerForQuery.DataLayer[0].infotemplates[1].id;
    statisticLayerNametble = "ATM";
    var counts;
    getBankNames(staticticLayerId);
    
    if (selected_dtcode != '0') {
      counts = DistStatistic[1];
      if (counts > 1000) {
        var param = new Query();
        param.where = "distlgd = " + selected_dtcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                districtStatisticMThousand(result);
              }
            }
          });
      } else {
        districtStatisticLThousand();
      }
    } else if (selected_stcode != '1000' && selected_dtcode == '0') {
      counts = StateStatistic[1];
      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                stateStatisticMThousand(result);
              }
            }
          });
      } else {
        stateStatisticLThousand();
      }
    }
  }

  function bankMitraStatistics() {
    console.log('BM');
    staticticLayerId = '7';
    statisticLayerNametble = "Bank Mitra";
    var counts;
    getBankNames(staticticLayerId);
    
    if (selected_dtcode != '0') {
      counts = DistStatistic[2];
      if (counts > 1000) {
        var param = new Query();
        param.where = "distlgd = " + selected_dtcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                districtStatisticMThousand(result);
              }
            }
          });
      } else {
        districtStatisticLThousand();
      }
    } else if (selected_stcode != '1000' && selected_dtcode == '0') {
      counts = StateStatistic[2];
      if (counts > 1000) {
        var param = new Query();
        param.where = "statelgd = " + selected_stcode;

        query.executeForIds(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), param)
          .then(function (result) {
            var resultLen = result.length;
            if (resultLen != 0) {
              if (resultLen >= 1000) {
                stateStatisticMThousand(result);
              }
            }
          });
      } else {
        stateStatisticLThousand();
      }
    }
  }

  function getBankNames(layerId) {
    var Param = new Query();
    Param.where = "1=1";
    Param.returnGeometry = false;
    Param.outFields = ["bankcode"];
    Param.returnDistinctValues = true;
    Param.orderByFields = ["bankcode"];

    query.executeQueryJSON(getQueryUrl(data.layerForQuery.DataLayer[0].Url, layerId), Param)
      .then(function (result) {
        allBankNameArray = [];
        console.log(result);
        var features = result.features;
        var namesArray = [];
        for (var i = 0; i < features.length; i++) {
          var name = features[i].attributes["bankcode"];
          if (name && name.trim() != "" && name != '' && name != ' ') {
            var upperValue = name.toUpperCase();
            if (namesArray.indexOf(upperValue) === -1) {
              namesArray.push(upperValue);
              allBankNameArray.push(name);
            }
          }
        }
      });
  }

  function districtStatisticMThousand(objIds) {
    bankwiseStatistic = [];

    var counts = 1;
    var tempObjIds = [];
    var temp = [];
    var promiseArray = [];
    var ObjectIds = objIds;
    var params = new Query();
    params.returnGeometry = true;
    params.outFields = ['*'];

    for (var i = 0; i < ObjectIds.length; i++) {
      if (counts <= 2000) {
        temp.push(ObjectIds[i]);
      } else {
        temp.push(ObjectIds[i]);
        tempObjIds.push(temp);
        temp = [];
        counts = 1;
      }

      if (i + 1 === ObjectIds.length) {
        tempObjIds.push(temp);
      }
      counts++;
    }

    for (var i = 0; i < tempObjIds.length; i++) {
      params.objectIds = tempObjIds[i];
      promiseArray.push(query.executeQueryJSON(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), params));
    }

    Promise.all(promiseArray).then(function (values) {
      var resultArray = [];
      console.log(values);
      var array = [];
      for (var j = 0; j < values.length; j++) {
        var larArray = values[j].features;
        for (var m = 0; m < larArray.length; m++) {
          array.push(larArray[m]);
        }
      }
      checkresult(array);
    });
  }

  function stateStatisticMThousand(objIds) {
    bankwiseStatistic = [];
    var counts = 1;
    var tempObjIds = [];
    var temp = [];
    var promiseArray = [];
    var ObjectIds = objIds;
    var params = new Query();
    params.returnGeometry = true;
    params.outFields = ['*'];

    for (var i = 0; i < ObjectIds.length; i++) {
      if (counts <= 2000) {
        temp.push(ObjectIds[i]);
      } else {
        temp.push(ObjectIds[i]);
        tempObjIds.push(temp);
        temp = [];
        counts = 1;
      }

      if (i + 1 === ObjectIds.length) {
        tempObjIds.push(temp);
      }
      counts++;
    }

    const mapServiceUrl = getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId);

    function queryBatch(objectIdsChunk) {
      const queryParams = new Query({
        where: "1=1",
        objectIds: objectIdsChunk,
        returnGeometry: true,
        outFields: ["*"],
      });

      return query.executeQueryJSON(mapServiceUrl, queryParams);
    }

    promiseArray = tempObjIds.map(chunk => queryBatch(chunk));

    Promise.all(promiseArray)
      .then(results => {
        const allFeatures = results.flatMap(result => result.features);
        console.log("Total features retrieved:", allFeatures.length);
        console.log("Features:", allFeatures);
        checkresult(allFeatures);
      })
      .catch(error => {
        console.error("Error querying features:", error);
      });
  }

  function districtStatisticLThousand() {
    bankwiseStatistic = [];
    var DistrictGeomQuery = new Query();

    DistrictGeomQuery.where = "distlgd = " + selected_dtcode;
    DistrictGeomQuery.returnGeometry = true;
    DistrictGeomQuery.outFields = ["*"];
    DistrictGeomQuery.outSpatialReference = SpRef;
    
    query.executeQueryJSON(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), DistrictGeomQuery)
      .then(function (result) {
        console.log(result);
        var features = result.features;

        list = [];
        array = [];

        let larArray = features;
        for (var m = 0; m < larArray.length; m++) {
          array.push(larArray[m]);
        }
        array.forEach(function (item) {
          list.push(item.attributes);
        });
        console.log(list);

        totalPages = Math.ceil(list.length / recordsPerPage);

        var fieldCode = "bankcode";
        for (var j = 0; j < allBankNameArray.length; j++) {
          var bankName = allBankNameArray[j];
          var bankCode = "";

          for (var k = 0; k < features.length; k++) {
            var name = features[k].attributes["bankcode"];

            if (name && name.trim() != "" && name != null) {
              var val = name.toUpperCase();
              var orgVal = bankName.toUpperCase();
              if (val == orgVal) {
                bankCode = features[k].attributes[fieldCode];
                if (bankCode != "") {
                  k = features.length;
                }
              }
            }
          }
          var tempary = [];
          for (var i = 0; i < features.length; i++) {
            var name = features[i].attributes[fieldCode];

            if (name && name.trim() != "" && name != null) {
              var val = name.toUpperCase();
              var orgVal = bankCode.toUpperCase();
              if (val == orgVal) {
                tempary.push(features[i]);
              }
            }
          }

          var obj = {};
          obj["name"] = bankName;
          obj["features"] = tempary;
          bankwiseStatistic.push(obj);
        }

        createBankwiseTbl(bankwiseStatistic);
      });
  }

  function stateStatisticLThousand() {
    bankwiseStatistic = [];
    var stateGeomQuery = new Query();

    stateGeomQuery.where = "statelgd=" + selected_stcode;
    stateGeomQuery.returnGeometry = true;
    stateGeomQuery.outFields = ["*"];
    
    query.executeQueryJSON(getQueryUrl(data.layerForQuery.DataLayer[0].Url, staticticLayerId), stateGeomQuery)
      .then(function (result) {
        console.log(result);
        var features = result.features;

        list = [];
        array = [];

        let larArray = features;
        for (var m = 0; m < larArray.length; m++) {
          array.push(larArray[m]);
        }
        array.forEach(function (item) {
          list.push(item.attributes);
        });
        console.log(list);

        totalPages = Math.ceil(list.length / recordsPerPage);

        var fieldCode = "bankcode";
        for (var j = 0; j < allBankNameArray.length; j++) {
          var bankName = allBankNameArray[j];
          var bankCode = "";

          for (var k = 0; k < features.length; k++) {
            var name = features[k].attributes["bankcode"];

            if (name && name.trim() != "" && name != null) {
              var val = name.toUpperCase();
              var orgVal = bankName.toUpperCase();
              if (val == orgVal) {
                bankCode = features[k].attributes[fieldCode];
                if (bankCode != "") {
                  k = features.length;
                }
              }
            }
          }
          var tempary = [];
          for (var i = 0; i < features.length; i++) {
            var name = features[i].attributes[fieldCode];
            if (name && name.trim() != "" && name != null) {
              var val = name.toUpperCase();
              var orgVal = bankCode.toUpperCase();
              if (val == orgVal) {
                tempary.push(features[i]);
              }
            }
          }

          var obj = {};
          obj["name"] = bankName;
          obj["features"] = tempary;
          bankwiseStatistic.push(obj);
        }
        createBankwiseTbl(bankwiseStatistic);
      });
  }

  function CreateList(response) {
    list = [];
    array = [];
    console.log(response);

    let larArray = response;
    for (var m = 0; m < larArray.length; m++) {
      array.push(larArray[m]);
    }
    array.forEach(function (item) {
      list.push(item.attributes);
    });
    console.log(list);

    totalPages = Math.ceil(list.length / recordsPerPage);
    if (tabname === "bank") {
      setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
      setResdata(list.slice(0, 1000));
    } else if (tabname === "atm") {
      setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
      setAtmResdata(list.slice(0, 1000));
    } else if (tabname === "mithra") {
      setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
      setMithraResdata(list.slice(0, 1000));
    } else if (tabname === "ippb") {
      const ippbTemplate = data.layerForQuery.DataLayer[0].infotemplates.find(t => t.id === "66");
      if (ippbTemplate) {
        setippbFields(ippbTemplate.fields);
        setippbResdata(list.slice(0, 1000));
      } else {
        console.error("IPPB template not found in infotemplates");
        setippbFields([]);
        setippbResdata(list.slice(0, 1000));
      }
    }
  }

  function checkresult(array) {
    var features = array;
    var fieldName = "bankcode";
    var fieldCode = "bankcode";

    bankwiseStatistic = [];

    for (var j = 0; j < allBankNameArray.length; j++) {
      var bankName = allBankNameArray[j];
      var bankCode = "";

      for (var k = 0; k < features.length; k++) {
        var name = features[k].attributes[fieldName];
        if (name && name.trim() !== "" && name !== null) {
          var val = name.toUpperCase();
          var orgVal = bankName.toUpperCase();
          if (val === orgVal) {
            bankCode = features[k].attributes[fieldCode];
            if (bankCode !== "") {
              break;
            }
          }
        }
      }

      var tempary = [];
      for (var i = 0; i < features.length; i++) {
        var name = features[i].attributes[fieldCode];
        if (name && name.trim() !== "" && name !== null) {
          var val = name.toUpperCase();
          var orgVal = bankCode.toUpperCase();
          if (val === orgVal) {
            tempary.push(features[i]);
          }
        }
      }

      var obj = {};
      obj["name"] = bankName;
      obj["features"] = tempary;
      bankwiseStatistic.push(obj);
    }

    createBankwiseTbl(bankwiseStatistic);
  }

  function createBankwiseTbl(value) {
    if (view) view.graphics.removeAll();
    layernameGlobal = statisticLayerNametble;

    const tableContainers = [
      'bankwiseTable_resultDiv',
      'atmwiseTable_resultDiv',
      'mithrawiseTable_resultDiv',
      'ippbwiseTable_resultDiv'
    ];

    tableContainers.forEach(containerId => {
      const container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = '';
      }
    });

    var formHeader = '<tr><th width="30%">Bank Code</th><th width="30%">Bank Name</th><th width="30%">Counts</th></tr>';

    tableContainers.forEach(containerId => {
      const container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = formHeader;
      }
    });

    var tablestr = '';

    for (var i = 0; i < value.length; i++) {
      var name = value[i].name;
      var count = value[i].features.length;
      var nameBank = "";

      if (value[i].features.length > 0) {
        const firstFeature = value[i].features[0];
        nameBank = firstFeature.attributes.bankname ||
          firstFeature.attributes.bank_name ||
          firstFeature.attributes.BankName ||
          name ||
          "N/A";
      } else {
        nameBank = "N/A";
      }

      if (count > 0) {
        var str = '<tr><td><a href="#" style="color:blue; text-decoration: none;">' + name + '</a></td><td>' + nameBank + '</td><td>' + count + '</td></tr>';
        tablestr += str;
      }
    }

    var tableId;
    if (tabname === "bank") {
      tableId = 'bankwiseTable_resultDiv';
    } else if (tabname === "atm") {
      tableId = 'atmwiseTable_resultDiv';
    } else if (tabname === "mithra") {
      tableId = 'mithrawiseTable_resultDiv';
    } else if (tabname === "ippb") {
      tableId = 'ippbwiseTable_resultDiv';
    }

    const table = document.getElementById(tableId);
    if (table) {
      table.innerHTML += tablestr;
      addRowClickHandlers(table, value);
    }
  }

  function addRowClickHandlers(table, bankwiseStatistic) {
    var rows = table.getElementsByTagName('tr');
    for (var i = 1; i < rows.length; i++) {
      rows[i].onclick = function () {
        if (this.getElementsByTagName('td').length > 0) {
          handleRowClick(this, bankwiseStatistic);
        }
      };
    }
  }

  function handleRowClick(row, bankwiseStatistic) {
    if (!bankwiseStatistic) {
      console.error("bankwiseStatistic is undefined");
      return;
    }

    if (AoigraphicsLayer) AoigraphicsLayer.graphics.removeAll();
    if (view) view.graphics.removeAll();

    var stringName = row.getElementsByTagName('td')[0].innerText;
    console.log("Clicked on:", stringName);

    if (stringName && stringName !== " " && stringName !== "N/A") {
      var isAvailable = false;
      var bankid;

      for (var k = 0; k < allBankNameArray.length; k++) {
        if (stringName === allBankNameArray[k]) {
          isAvailable = true;
          specificAoiBankName = stringName;
          bankid = k;
          break;
        }
      }

      if (isAvailable && bankwiseStatistic[bankid] && bankwiseStatistic[bankid].features) {
        var features = bankwiseStatistic[bankid].features;

        var currentTemplate = null;

        if (staticticLayerId) {
          currentTemplate = data.layerForQuery.DataLayer[0].infotemplates.find(t =>
            t.id && t.id.toString() === staticticLayerId.toString()
          );
        }

        if (!currentTemplate) {
          currentTemplate = data.layerForQuery.DataLayer[0].infotemplates.find(t =>
            t.title === statisticLayerNametble || t.name === statisticLayerNametble
          );
        }

        if (!currentTemplate && data.layerForQuery.DataLayer[0].infotemplates.length > 0) {
          currentTemplate = data.layerForQuery.DataLayer[0].infotemplates[0];
        }

        if (currentTemplate && currentTemplate.fields) {
          var infoContent = _generateInfoTemplateContent(currentTemplate.fields);
          var infoTemplate = new PopupTemplate(
            currentTemplate.title || "Feature Info",
            infoContent
          );

          var highlightSymbol = new SimpleMarkerSymbol({
            style: "circle",
            size: 12,
            color: [0, 0, 0, 0],
            outline: {
              color: [255, 0, 0],
              width: 1
            }
          });

          for (var j = 0; j < features.length; j++) {
            if (features[j] && features[j].geometry) {
              var graphic = new Graphic({
                geometry: features[j].geometry,
                symbol: highlightSymbol,
                attributes: features[j].attributes,
                popupTemplate: infoTemplate
              });
              if (AoigraphicsLayer) AoigraphicsLayer.add(graphic);
            }
          }
        } else {
          console.warn("No template found for highlighting");
          for (var j = 0; j < features.length; j++) {
            if (features[j] && features[j].geometry) {
              var graphic = new Graphic({
                geometry: features[j].geometry,
                symbol: new SimpleMarkerSymbol({
                  style: "circle",
                  size: 12,
                  color: [0, 0, 0, 0],
                  outline: { color: [255, 0, 0], width: 1 }
                })
              });
              if (AoigraphicsLayer) AoigraphicsLayer.add(graphic);
            }
          }
        }
      } else {
        console.warn("Bank data not available for:", stringName);
      }
    }
  }

  function _generateInfoTemplateContent(fields) {
    var content = "<table>";
    var fieldsLength = fields.length;
    for (var x = 0; x < fieldsLength; x++) {
      var field = fields[x];
      content += "<tr><td>" + field.alias + "</td> <td>:</td> <td>  ${" + field.name + "} </td> </tr>";
    }
    content += "</table>";
    return content;
  }

  function generateResultTableAOI(tableValues, fields, attributes) {
    var fieldsContent = "";
    var dataContent = "";
    for (var x = 0; x < fields.length; x++) {
      var field = fields[x];
      var tmpattribute = '';
      if (attributes[field.name] !== undefined && attributes[field.name] !== 'undefined') {
        tmpattribute = attributes[field.name];
      }
      if (tableValues === "") {
        fieldsContent += "<th>" + field.alias + "</th>";
      }
      if (field.alias === "BSR CODE" || field.alias === "ATM Code" || field.alias === "Bankmitra Code") {
        dataContent += "<td><a href='#' style='color:blue'>" + tmpattribute + "</a></td>";
      } else {
        dataContent += "<td>" + tmpattribute + "</td>";
      }
    }
    if (tableValues === "") {
      tableValues += "<tr>" + fieldsContent + "</tr>";
    }
    tableValues += "<tr>" + dataContent + "</tr>";

    return tableValues;
  }

  function _doMaskOperation(ObjGeometry) {
    if (!mskgraphicLayer) return;

    var tmpdistGeometry = ObjGeometry;
    var maskingSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
      new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([255, 85, 0]), 1.5),
      new Color([255, 255, 255, 1]));

    if (ObjGeometry.type === 'polygon') {
      try {
        if (maskBufferredGeometry === null) {
          maskBufferredGeometry = new Circle({
            center: ObjGeometry.centroid,
            geodesic: false,
            radius: 8000,
            radiusUnit: 'kilometers'
          });

          var differenceGeometry = geometryEngine.difference(maskBufferredGeometry, ObjGeometry);
          var graphic = new Graphic({
            geometry: differenceGeometry,
            symbol: maskingSymbol
          });
          mskgraphicLayer.add(graphic);
        } else {
          var differenceGeometry = geometryEngine.difference(maskBufferredGeometry, ObjGeometry);
          var graphic = new Graphic({
            geometry: differenceGeometry,
            symbol: maskingSymbol
          });
          mskgraphicLayer.add(graphic);
        }
      } catch (err) {
        console.log(err.message);
      }
    }
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    window.location.href = 'https://webgis2.nic.in/dbt1/';
  };

  const menuItems = [
    { icon: "list", label: "AOI", cardId: "aoi" },
    { icon: "layers", label: "Layers", cardId: "layers" },
    { icon: "radar", label: "Buffer", cardId: "buffer" },
    { icon: "route", label: "Direction", cardId: "location" },
    { icon: "straighten", label: "Measure", cardId: "measure" },
    {
      icon: "near_me",
      label: isMobile ? "NBP" : "Near By Points",
      cardId: "nearby"
    },
  ];

  const handleCardToggle = (cardId) => {
    if (cardId == "location") {
      setActiveCard("");
      document.getElementById("myCard").style.display = "block";
    } else {
      setActiveCard(activeCard === cardId ? null : cardId);
      document.getElementById("myCard").style.display = "none";
    }
  };

  const handleCloseCard = () => {
    setActiveCard(null);
    if (AoigraphicsLayer) AoigraphicsLayer.graphics.removeAll();
    if (view) {
      view.graphics.removeAll();
      view.map.findLayerById("Zoompoint")?.graphics.removeAll();
      view.map.findLayerById("Bankpoint")?.graphics.removeAll();
      view.map.findLayerById("incidentGL_MB")?.graphics.removeAll();
      view.map.findLayerById("finalSchoolsGL_2KM_MB")?.graphics.removeAll();
      view.map.findLayerById("routeGL_MB")?.graphics.removeAll();
    }
    setState('');
    setDistrict('');
    setIsTableCardOpen(false);
    if (higraphicLayer) higraphicLayer.graphics.removeAll();
    if (mskgraphicLayer) mskgraphicLayer.graphics.removeAll();
  };

  const handleCloseDirectionCard = () => {
    if (directionsWidget) directionsWidget.viewModel.reset();
    document.getElementById("myCard").style.display = "none";
  };

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleCloseTableCard = () => {
    setIsTableCardOpen(false);
  };

  useEffect(() => {
    if (isTableCardOpen && !key) {
      setKey("bank");
      setTimeout(() => {
        showbanktbl();
      }, 100);
    }
  }, [isTableCardOpen, key]);

  // Initial load of states
  useEffect(() => {
    const params = new Query({
      returnGeometry: false,
      outFields: ["state_lgd", "stname"],
      where: "1=1",
      outSpatialReference: 3857,
      orderByFields: ["stname"]
    });

    query.executeQueryJSON(getQueryUrl(STATE_LAYER_URL), params)
      .then(getStateResults)
      .catch(err => console.log("Initial state load error:", err));

    function getStateResults(response) {
      if (response.features && response.features.length > 0) {
        var stateFeatures = response.features;
        var optionsArray = [];
        for (var i = 0; i < stateFeatures.length; i++) {
          optionsArray.push({
            value: stateFeatures[i].attributes["state_lgd"],
            label: stateFeatures[i].attributes["stname"],
          });
        }
        setOptions(optionsArray);
      }
    }
  }, []);

  // Map initialization
  useEffect(() => {
    if (mapRef.current) {
      map = new Map();

      const nicStreetLiteConfig = data.mapConfig.basemaps.find(basemap =>
        basemap.tittle === "NIC Street Lite"
      );

      if (nicStreetLiteConfig) {
        const nicStreetLiteLayer = new VectorTileLayer({
          url: nicStreetLiteConfig.url,
          apiKey: nicStreetLiteConfig.token,
          title: "NIC Street Lite"
        });

        map.basemap = new Basemap({
          baseLayers: [nicStreetLiteLayer],
          title: "NIC Street Lite"
        });
      }

      view = new MapView({
        container: mapRef.current,
        map: map,
        zoom: 1,
        minzoom: 4,
        center: [78.9629, 22.5937],
      });
      view.constraints.minZoom = 4;

      setMapview(view);

      mskgraphicLayer = new GraphicsLayer();
      mskgraphicLayer.listMode = "hide";
      mskgraphicLayer.id = "mask";

      AoigraphicsLayer = new GraphicsLayer();

      let symbolbc = {
        type: "simple-fill",
        color: [0, 0, 0, 0],
        style: "solid",
        outline: {
          color: [128, 128, 128],
          width: 1
        }
      };

      var rendererbc = new SimpleRenderer({
        symbol: symbolbc
      });

      let symboldt = {
        type: "simple-fill",
        color: [0, 0, 0, 0],
        style: "solid",
        outline: {
          color: [128, 128, 128],
          width: 1
        }
      };

      var rendererdt = new SimpleRenderer({
        symbol: symboldt
      });

      var adminLayer = new MapImageLayer({
        url: data.layerForQuery.Admin.Url,
        title: "Admin",
        id: "Admin",
        sublayers: [
          {
            id: 1,
            title: "State",
            renderer: rendererbc
          },
          {
            id: 2,
            title: "District",
            minScale: 4000000,
            renderer: rendererdt
          }]
      });

      map.add(mskgraphicLayer);

      higraphicLayer = new GraphicsLayer();
      higraphicLayer.listMode = "hide";
      map.add(higraphicLayer);

      zoomGraphicLayer = new GraphicsLayer();
      zoomGraphicLayer.listMode = "hide";
      zoomGraphicLayer.id = "Zoompoint";

      const banklayersGraphicLayer = new GraphicsLayer();
      banklayersGraphicLayer.listMode = "hide";
      banklayersGraphicLayer.id = "Bankpoint";

      var incidentGL_MB = new GraphicsLayer();
      incidentGL_MB.id = "incidentGL_MB";
      incidentGL_MB.listMode = "hide";

      var finalSchoolsGL_2KM_MB = new GraphicsLayer();
      finalSchoolsGL_2KM_MB.id = "finalSchoolsGL_2KM_MB";

      var routeGL_MB = new GraphicsLayer();
      routeGL_MB.id = "routeGL_MB";

      var adminFeatureLayer1 = new MapImageLayer({
        url: data.layerForQuery.DataLayer[0].Url,
        title: "Bank Assets",
        id: "Bank_123",
        visible: true,
        customParameters: {
          "infoTemplate": data.layerForQuery.DataLayer[0].infotemplates
        }
      });
      view.map.addMany([adminFeatureLayer1]);

      map.add(AoigraphicsLayer);
      map.add(zoomGraphicLayer);
      map.add(banklayersGraphicLayer);
      map.add(finalSchoolsGL_2KM_MB);
      map.add(routeGL_MB);
      map.add(incidentGL_MB);

      view.when(adminFeatureLayer1).then(function () {
        adminFeatureLayer1.when(() => {
          console.log("MapService Loaded:", adminFeatureLayer1);
          console.log("Sublayers:", adminFeatureLayer1.sublayers.toArray());
          adminFeatureLayer1.sublayers.forEach(function (sublayer, index) {
            checkSubLayers(sublayer, data.layerForQuery.DataLayer[0].infotemplates);
          });
        });
      });

      function checkSubLayers(sublayer, popupTemplateFields) {
        if (sublayer.sublayers != undefined) {
          sublayer.sublayers.forEach(function (sublayer, index) {
            checkSubLayers(sublayer, popupTemplateFields);
          });
        } else {
          for (var j = 0; j < popupTemplateFields.length; j++) {
            var layerId = parseInt(sublayer.id);
            var templateId = parseInt(popupTemplateFields[j].id);

            if (layerId === templateId) {
              var curFieldInfo = [];
              var curPopFields = popupTemplateFields[j].fields;

              for (var p = 0; p < curPopFields.length; p++) {
                curFieldInfo.push({ fieldName: curPopFields[p].name });
              }

              sublayer.popupTemplate = {
                title: sublayer.title + " Info",
                outFields: ["*"],
                content: populationChange,
                fieldInfos: curFieldInfo,
                popupTemplateFields: popupTemplateFields[j]
              };
              console.log("Popup template set for layer:", sublayer.id, sublayer.title);
            }
          }
        }
      }

      function populationChange(evt) {
        console.log(evt);
        const div = document.createElement("div");
        var fields;
        var title;
        
        if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[0].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[0].fields;
          title = "Bank Branch";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[1].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[1].fields;
          title = "ATM";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[2].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[2].fields;
          title = "Bank Mitra";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[3].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[3].fields;
          title = "Village Locations";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[4].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[4].fields;
          title = "CSC";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[5].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[5].fields;
          title = "PostOffice";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[6].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[6].fields;
          title = "State Head Quarter";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[7].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[7].fields;
          title = "District Head Quarter";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[8].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[8].fields;
          title = "Sub District Head Quarter";
        } else if (evt.graphic.sourceLayer.id === parseInt(data.layerForQuery.DataLayer[0].infotemplates[9].id)) {
          fields = data.layerForQuery.DataLayer[0].infotemplates[9].fields;
          title = "IPPB";
        }

        var content = "";

        content += '<div class="hzLine">';
        content += "</div>";

        content += "<table id='infotbl'>";
        if (fields) {
          for (var k = 0; k < fields.length; k++) {
            if (
              evt.graphic.attributes[fields[k].name] &&
              evt.graphic.attributes[fields[k].name]
                .toString()
                .trim() !== ""
            ) {
              content +=
                "<tr><td><b>" +
                fields[k].alias +
                "</td></b>" +
                "<td><b>: </b></td><td>" +
                evt.graphic.attributes[fields[k].name] +
                "</td></tr>";
            }
          }
        }
        content += "</table>";
        div.innerHTML = content;

        view.popup.open({
          title: title
        });
        view.popup.content = content;
      }

      for (var i = 0; i < data.mapConfig.basemaps.length; i++) {
        var currentBasemap = data.mapConfig.basemaps[i];

        if (data.mapConfig.basemaps[i].tittle === "NIC Street") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "NIC Terrain") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "NIC Satellite Imagery") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "NIC Street Lite") {
          const curBasemap = new Basemap({
            baseLayers: [new VectorTileLayer({
              url: currentBasemap.url,
              apiKey: currentBasemap.token,
            })],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "NIC Base") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "World Street Map") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "World Imagery") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        } else if (data.mapConfig.basemaps[i].tittle === "World Topographic Map") {
          const curBasemap = new Basemap({
            baseLayers: [
              new TileLayer({
                url: currentBasemap.url
              })
            ],
            title: currentBasemap.tittle,
            id: "Basemap-" + i,
            thumbnailUrl: ""
          });
          basemapCollection.push(curBasemap);
        }
      }

      var allSource = [];

      var laysource = [
        {
          layer: new FeatureLayer({
            url: getQueryUrl(data.layerForQuery.DataLayer[0].Url, data.layerForQuery.DataLayer[0].infotemplates[0].id),
          }),
          "name": "Bank Branch",
          "placeholder": "Find by IFSC Code",
          "searchFields": [
            "IFSC"
          ],
          "displayField": "IFSC",
          "exactMatch": false,
          "searchInCurrentMapExtent": false,
          "panToScale": false,
          "zoomScale": null,
          "maxSuggestions": 6,
          "maxResults": 6,
          "type": "query"
        },
        {
          layer: new FeatureLayer({
            url: getQueryUrl(data.layerForQuery.DataLayer[0].Url, data.layerForQuery.DataLayer[0].infotemplates[1].id),
          }),
          "name": "ATM",
          "placeholder": "Find by ATM Code",
          "searchFields": [
            "ATMCode"
          ],
          "displayField": "ATMCode",
          "exactMatch": false,
          "searchInCurrentMapExtent": false,
          "panToScale": false,
          "zoomScale": null,
          "maxSuggestions": 6,
          "maxResults": 6,
          "type": "query"
        },
        {
          layer: new FeatureLayer({
            url: getQueryUrl(data.layerForQuery.DataLayer[0].Url, data.layerForQuery.DataLayer[0].infotemplates[2].id),
          }),
          "name": "Bank Mitra",
          "placeholder": "Find by IFSC Code",
          "searchFields": [
            "BankMitraCode"
          ],
          "displayField": "BankMitraCode",
          "exactMatch": false,
          "searchInCurrentMapExtent": false,
          "panToScale": false,
          "zoomScale": null,
          "maxSuggestions": 6,
          "maxResults": 6,
          "type": "query"
        }
      ];
      
      allSource.push(laysource[0]);
      allSource.push(laysource[1]);
      allSource.push(laysource[2]);
      allSource.push(mysource.sources[3]);

      searchWidgetheader = new Search({
        view: view,
        allPlaceholder: "Search Bank",
        includeDefaultSources: false,
        container: document.getElementById("searchAll"),
        sources: allSource,
        popupEnabled: false
      });

      view.ui.add(searchWidgetheader, {
        position: "top-right"
      });

      const widgetNode = searchWidgetheader.container;
      widgetNode.style.position = "absolute";
      widgetNode.style.top = "50px";

      searchWidgetheader.on("select-result", function (event) {
        console.log(event);
        var result = event.result;
        if (result) {
          if (event.source.type !== 'locator')
            highlightDistrict(result);

          if (event.source.type !== 'undefined') {
            const point = {
              type: "point",
              longitude: event.result.feature.geometry.longitude,
              latitude: event.result.feature.geometry.latitude
            };

            const simpleMarkerSymbol = {
              type: "simple-marker",
              color: [226, 119, 40, 0],
              outline: {
                color: [255, 255, 255],
                width: 1
              }
            };

            const pointGraphic = new Graphic({
              geometry: point,
              symbol: simpleMarkerSymbol
            });
          }
        }
      });

      searchWidgetheader.on("search-clear", function (event) {
        view.graphics.removeAll();
      });

      searchWidgetheader.watch("activeSourceIndex", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          searchWidgetheader.searchTerm = "";
          view.graphics.removeAll();
        }
      });

      function highlightDistrict(result) {
        view.graphics.removeAll();

        var outlineSymbol = new SimpleLineSymbol({
          color: new Color([0, 0, 255]),
          width: 2
        });

        var zoomsymbol = new SimpleMarkerSymbol({
          outline: {
            color: [255, 0, 0],
            width: 5
          }
        });

        var graphic = new Graphic({
          geometry: result.feature.geometry,
          symbol: zoomsymbol
        });

        view.graphics.add(graphic);
      }

      view
        .when(() => {
          if (!directionsWidget) {
            const routeLayer = new RouteLayer({
              url: data.layerForQuery.Route.Url,
              listMode: "hide",
            });

            view.map.add(routeLayer);

            directionsWidget = new Directions({
              layer: routeLayer,
              view: view,
              container: directionsDiv.current,
            });
          }

          const scaleBar = new ScaleBar({ view });
          view.ui.add(scaleBar, "bottom-left");

          const esriLogoNode = document.createElement("div");
          esriLogoNode.innerHTML = `
            <img class="icon_mob"
              src="img/bhartmap.png"
              alt="Esri Logo"
              style="width: 160px; position: fixed; z-index: 99; bottom: 18px; right: 0; left: 0; margin: 0 auto; opacity: 1;"
            />
          `;
          esriLogoNode.onclick = () =>
            window.open(
              "https://bharatmaps.gov.in/BharatMaps/Home/Map",
              "_blank"
            );
          view.ui.add(esriLogoNode, "bottom-right");
        })
        .catch((error) => {
          console.error("Error initializing the view:", error);
        });

      return () => {
        if (view) {
          view.destroy();
        }
      };
    }
  }, []);

  const handleToggle = () => {
    if (!isBasemapVisible) {
      setAnimate(true);
      setTimeout(() => setBasemapVisible(true), 0);
    } else {
      setAnimate(false);
      setTimeout(() => setBasemapVisible(false), 300);
    }
  };

  const basemapChange = (evt) => {
    console.log(evt);
    if (evt === "nicstreetlite") {
      map.basemap = basemapCollection[1];
    } else if (evt === "streets-vector") {
      map.basemap = basemapCollection[5];
    } else if (evt === "satellite") {
      map.basemap = basemapCollection[6];
    } else if (evt === "NICbase") {
      map.basemap = basemapCollection[3];
    } else if (evt === "Terrain") {
      map.basemap = basemapCollection[2];
    } else if (evt === "nicstreet") {
      map.basemap = basemapCollection[0];
    } else if (evt === "nomap") {
      map.basemap = "";
    }
  };

  const updateTabTitle = (tabKey, newTitle) => {
    setTabTitles((prevTitles) => ({
      ...prevTitles,
      [tabKey]: newTitle,
    }));
  };

  const tabselect = (evt) => {
    tabname = evt;

    if (evt !== key) {
      setAtmResdata([]);
      setResdata([]);
      setMithraResdata([]);
      setippbResdata([]);
      setCurrentPages(1);

      if (evt === "bank") {
        setKey(evt);
        setTimeout(function () { showbanktbl(); }, 500);
      } else if (evt === "atm") {
        setKey(evt);
        setTimeout(function () { showAtmtbl(); }, 500);
      } else if (evt === "mithra") {
        setKey(evt);
        setTimeout(function () { showmithratbl(); }, 500);
      } else if (evt === "ippb") {
        setKey(evt);
        setTimeout(function () { showippbtbl(); }, 500);
      }
    }
  };

  const totalSteps = 20;
  const visibleSteps = 5;
  let currentPage = 1;

  function createPagination() {
    const paginationContainer = document.getElementById('pagination-container');
    if (!paginationContainer) return;

    paginationContainer.innerHTML = '';

    const leftArrow = document.createElement('button');
    leftArrow.textContent = '<';
    leftArrow.disabled = currentPage === 1;
    leftArrow.onclick = () => {
      if (currentPage > 1) {
        currentPage--;
        createPagination();
      }
    };
    paginationContainer.appendChild(leftArrow);

    const start = Math.max(1, currentPage - Math.floor(visibleSteps / 2));
    const end = Math.min(totalSteps, start + visibleSteps - 1);

    for (let i = start; i <= end; i++) {
      const button = document.createElement('button');
      button.textContent = i;
      button.classList.toggle('active', i === currentPage);
      button.onclick = () => {
        currentPage = i;
        createPagination();
      };
      paginationContainer.appendChild(button);
    }

    const rightArrow = document.createElement('button');
    rightArrow.textContent = '>';
    rightArrow.disabled = currentPage === totalSteps;
    rightArrow.onclick = () => {
      if (currentPage < totalSteps) {
        currentPage++;
        createPagination();
      }
    };
    paginationContainer.appendChild(rightArrow);
  }

  const getCurrentPageData = (page) => {
    const startIndex = (page - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;

    if (tabname === "bank") {
      setResdata(list.slice(startIndex, endIndex));
    } else if (tabname === "atm") {
      setAtmResdata(list.slice(startIndex, endIndex));
    } else if (tabname === "mithra") {
      setMithraResdata(list.slice(startIndex, endIndex));
    } else if (tabname === "ippb") {
      setippbResdata(list.slice(startIndex, endIndex));
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPages(page);
      getCurrentPageData(page);
    }
  };

  const RowHandler = (latitude, longitude) => {
    view.map.findLayerById("Zoompoint")?.graphics.removeAll();
    const point = new Point({
      longitude: longitude,
      latitude: latitude
    });

    view.goTo({
      target: point,
      zoom: 15
    });
    
    var zoomsymbol = new SimpleMarkerSymbol({
      outline: {
        color: [255, 0, 0],
        width: 5
      }
    });

    view.map.findLayerById("Zoompoint")?.add(new Graphic({
      geometry: point,
      symbol: zoomsymbol
    }));
  };

  const handleZoomOut = () => {
    if (view) {
      view.goTo({
        center: [77, 24],
        zoom: 4
      });
    }
  };

  const handleClearMap = () => {
    if (mskgraphicLayer) {
      mskgraphicLayer.graphics.removeAll();
      maskBufferredGeometry = null;
    }

    if (higraphicLayer) {
      higraphicLayer.graphics.removeAll();
    }

    if (AoigraphicsLayer) {
      AoigraphicsLayer.graphics.removeAll();
    }

    if (view) {
      view.graphics.removeAll();

      const layersToClear = ["Zoompoint", "Bankpoint", "incidentGL_MB", "finalSchoolsGL_2KM_MB", "routeGL_MB"];
      layersToClear.forEach(layerId => {
        const layer = view.map.findLayerById(layerId);
        if (layer) {
          layer.graphics.removeAll();
        }
      });

      if (searchWidgetheader) {
        searchWidgetheader.clear();
      }

      if (directionsWidget) {
        directionsWidget.viewModel.reset();
      }
    }

    setState("");
    setDistrict("");
    setIsTableCardOpen(false);
    setResdata([]);
    setAtmResdata([]);
    setMithraResdata([]);
    setippbResdata([]);
    setCurrentPages(1);
    view.popup.visible = false;
    handleCloseCard();
  };

  return (
    <div className="container-fluid p-0" style={{ height: "100vh" }}>
      <GisHeader />
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "4px solid #fff",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>

          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}
      <div style={{ position: "relative", height: "100%" }}>
        <div ref={mapRef} style={{ width: "100%", height: "100%" }}></div>
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: 1000,
          }}
        >
          <div style={{ zIndex: "99" }}>
            <Button className='mobsidebtn'
              variant="primary"
              onClick={toggleSidebar}
              style={{ position: 'absolute', top: '20px', left: '0px', borderRadius: "0px 10px 10px 0px" }}
            >
              <i className="bi bi-list"></i>
            </Button>

            <div
              className={`card floating-sidebar ${isSidebarOpen ? 'open fade-in-left' : ''}`}
              style={{
                position: 'fixed',
                top: 65,
                left: isSidebarOpen ? '0' : '-100%',
                width: 'min-content',
                height: 'auto',
                backgroundColor: '#f8f9fa',
                boxShadow: '2px 5px 5px rgba(0,0,0,0.5)',
                transition: 'left 0.3s ease-in-out',
                zIndex: '1040',
                borderRadius: '0px 10px 10px 0px',
              }}
            >
              <div className="card-body menu-container" style={{ padding: "5px" }}>
                <ul
                  className="list-unstyled mb-0 icontext "
                  style={{ justifyContent: "space-around", width: "auto" }}
                >
                  {menuItems.map((item, index) => (
                    <li
                      className="d-flex flex-column align-items-center p-2"
                      key={index}
                      style={{
                        textAlign: "center",
                        borderBottom: index !== menuItems.length - 1 ? "1px solid #ccc" : "none",
                      }}
                      onClick={() => item.cardId && handleCardToggle(item.cardId)}
                    >
                      {item.isButton ? (
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "0",
                          }}
                          onClick={item.onClick}
                        >
                          <span className="material-icons mI">
                            {item.icon}
                          </span>
                          <span >{item.label}</span>
                        </button>
                      ) : (
                        <>
                          <span className="material-icons mI" style={{ cursor: "pointer" }}>
                            {item.icon}
                          </span>
                          <span style={{ fontSize: "12px" }}>{item.label}</span>
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {menuItems.map((item) => (
              activeCard === item.cardId && (
                <div
                  className={`card ${item.cardId}-card-animation open-card-animation mobilecard`}
                  key={item.cardId}
                  style={{
                    position: 'fixed',
                    top: '90px',
                    right: '10px',
                    width: '300px',
                    height: 'auto',
                    backgroundColor: '#f8f9fa',
                    boxShadow: '2px 5px 5px rgba(0,0,0,0.5)',
                    zIndex: '1050',
                    borderRadius: '10px 10px 10px 10px',
                    zoom: 0.9
                  }}
                >
                  <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: "#dcf5f2", borderRadius: "10px 10px 0px 0px" }}>
                    <div className=" d-flex align-items-center" >
                      <span className="material-icons" style={{ fontSize: '20px', marginRight: '10px' }}>
                        {item.icon}
                      </span>
                      <h5 className="card-title mb-0" style={{ fontSize: "large", fontWeight: "700" }}>{item.label}</h5>
                    </div>
                    <div>
                      <i
                        className={`material-icons`}
                        style={{
                          fontSize: '20px',
                          cursor: 'pointer',
                          marginRight: '10px',
                        }}
                        onClick={handleToggleCollapse}
                      >
                        {isCollapsed ? 'expand_more' : 'expand_less'}
                      </i>
                      <i
                        className="material-icons"
                        style={{
                          fontSize: '20px',
                          cursor: 'pointer',
                        }}
                        onClick={handleCloseCard}
                      >
                        close
                      </i>
                    </div>
                  </div>

                  <div
                    className={`card-body ${isCollapsed ? 'collapse' : ''}`}
                    style={{
                      overflow: 'auto',
                      transition: 'height 0.3s ease',
                      padding: '5px',
                      maxHeight: '500px'
                    }}
                  >
                    {item.cardId === 'aoi' && (
                      <div>
                        <label>State</label>
                        <select
                          className="form-select"
                          value={state}
                          onChange={handleStateChange}
                          style={{ width: "100%", marginBottom: "10px" }}
                        >
                          <option value="">Select State</option>
                          {options.map((stateOption) => (
                            <option key={stateOption.value} value={stateOption.value}>{stateOption.label}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {state && item.cardId === 'aoi' && (
                      <div>
                        <label>District</label>
                        <select
                          className="form-select"
                          value={district}
                          onChange={handleDistrictChange}
                          style={{ width: "100%" }}
                        >
                          <option value="">Select District</option>
                          {options2.map((districtOption) => (
                            <option key={districtOption.value} value={districtOption.value}>{districtOption.label}</option>
                          ))}
                        </select>
                        <br></br> <br></br>
                        <div class="table-container"></div>
                      </div>
                    )}

                    <div
                      className={`card-body ${isCollapsed ? 'collapse' : ''}`}
                      style={{
                        overflow: 'hidden',
                        transition: 'height 0.3s ease',
                        padding: '5px',
                      }}
                    >
                      {item.cardId === 'measure' && (
                        <MeasureTool view={mapview} />
                      )}
                      {item.cardId === 'buffer' && (
                        <BufferTool view={mapview} />
                      )}
                      {item.cardId === 'layers' && (
                        <GisLayer view={mapview} CardOpen={isTableCardOpen} />
                      )}
                      {item.cardId === 'nearby' && (
                        <Nearby view={mapview} states={options} />
                      )}
                      {item.cardId === 'pointdistance' && (
                        <NearByRoute view={mapview} states={options} />
                      )}
                    </div>
                  </div>
                </div>
              )
            ))}

            <Card id="myCard" className={`card ${'location'}-card-animation open-card-animation mobcardopen`}
              style={{
                position: 'fixed',
                top: '90px',
                right: '10px',
                width: '300px',
                height: 'auto',
                overflow: "hidden",
                backgroundColor: '#f8f9fa',
                boxShadow: '2px 5px 5px rgba(0,0,0,0.5)',
                zIndex: '1050',
                borderRadius: '10px 10px 10px 10px',
                display: directionRef.current ? "block" : "none",
                zoom: 0.9
              }}
            >
              <Card.Header className="d-flex justify-content-between" style={{ backgroundColor: "#dcf5f2", height: "45px", }}>
                <div className="d-flex align-items-center" >
                  <span className="material-icons" style={{ fontSize: '20px', marginRight: '10px' }}>
                    route
                  </span>
                  <h5 className="card-title mb-0" style={{ fontSize: "large", fontWeight: "700" }}>Direction</h5>
                </div>
                <Button variant="link" onClick={handleCloseDirectionCard}>
                  <i className="material-icons" style={{ fontSize: '24px' }}>close</i>
                </Button>
              </Card.Header>
              <Card.Body>
                <div style={{ maxHeight: '30rem', overflowY: 'auto' }}>
                  <div
                    className="direction-widget"
                    ref={directionsDiv}
                  ></div>
                </div>
              </Card.Body>
            </Card>

            {isTableCardOpen && (
              <Draggable
                disabled={window.innerWidth <= 768}
                handle=".drag-handle"
              >
                <div
                  style={{
                    position: 'fixed',
                    bottom: '5px',
                    left: '5%',
                    transform: 'translateX(-50%)',
                    zIndex: 1060,
                    width: "30%",
                    zoom: 0.8
                  }} className='mob_bot_card'
                >
                  <Card
                    className={`card-container card_drag_mob ${isMinimized ? 'card-minimized' : 'card-maximized'}`}
                    style={{
                      borderRadius: '10px'
                    }}
                  >
                    <Card.Header className="d-flex justify-content-between drag-handle" style={{ backgroundColor: "#dcf5f2", height: "45px" }}>
                      <h5 style={{ fontSize: "large", fontWeight: "700" }}>Result Table</h5>
                      <div className="d-flex">
                        <Button variant="link" onClick={() => setIsMinimized(!isMinimized)}>
                          <i className="material-icons" style={{ fontSize: '24px' }}>
                            {isMinimized ? 'fullscreen' : 'minimize'}
                          </i>
                        </Button>
                        <Button variant="link" onClick={handleCloseTableCard}>
                          <i className="material-icons" style={{ fontSize: '24px' }}>close</i>
                        </Button>
                      </div>
                    </Card.Header>

                    {!isMinimized && (
                      <Card.Body>
                        <Tabs
                          id="controlled-tab-example"
                          activeKey={key}
                          onSelect={tabselect}
                          className="mb-3"
                        >
                          <Tab eventKey="bank" title={tabTitles.bank}>
                            <div className="table-responsive" style={{ maxHeight: '15rem', overflowY: 'auto' }}>
                              <table class="tableclass table table-bordered table-striped table-hover" id="bankwiseTable_resultDiv" border="1"></table>
                            </div>
                          </Tab>
                          <Tab eventKey="atm" title={tabTitles.atm}>
                            <div style={{ maxHeight: '15rem', overflowY: 'auto' }}>
                              <table class="tableclass table table-bordered table-striped table-hover" id="atmwiseTable_resultDiv" border="1"></table>
                            </div>
                          </Tab>
                          <Tab eventKey="mithra" title={tabTitles.mithra}>
                            <div style={{ maxHeight: '15rem', overflowY: 'auto' }}>
                              <table class="tableclass table table-bordered table-striped table-hover" id="mithrawiseTable_resultDiv" border="1"></table>
                            </div>
                          </Tab>
                          <Tab eventKey="ippb" title={tabTitles.ippb}>
                            <div style={{ maxHeight: '15rem', overflowY: 'auto' }}>
                              <table class="tableclass table table-bordered table-striped table-hover" id="ippbwiseTable_resultDiv" border="1"></table>
                            </div>
                          </Tab>
                        </Tabs>
                      </Card.Body>
                    )}
                  </Card>
                </div>
              </Draggable>
            )}
          </div>

          {isBasemapVisible && (
            <div
              className={`p-2 bg-light basecardmob ${animate ? "slide-in" : "slide-out"
                }`}
              style={{
                position: "fixed",
                bottom: "15px",
                right: "68px",
                transform: "translateX(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                width: "max-content",
              }}
            >
              <div className="mobile_image_basemap"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {[
                  {
                    name: "NIC Streets",
                    value: "nicstreetlite",
                    img: Streets,
                  },
                  {
                    name: "Satellite",
                    value: "satellite",
                    img: satellite,
                  },
                  {
                    name: "NIC Terrain",
                    value: "Terrain",
                    img: NIC_Terrain,
                  },
                  {
                    name: "NIC Base",
                    value: "NICbase",
                    img: NIC_Base,
                  },
                  {
                    name: "Street",
                    value: "streets-vector",
                    NIC_Streetmap_url: "https://mapservice.gov.in/mapserviceserv176/rest/services/Street/StreetMap/MapServer?Token=2WX3Wwf1awqcW6chbyE7SwtNg7HqV4GVQ9YxTzPCftmpkToSZzfRTWpHj1-otL7qOCd8dwtPwe6z9sbY1TrTkQ..",
                    token: "vr3FWgonWnALlMT_5tSlR2akHNxKdMg1gfYC3yd2Cfb4Ot--sV6Ds7akIBsecrzn",
                    img: esri,
                  },
                  {
                    name: "No Basemap",
                    value: "nomap",
                    img: No_Base,
                  },
                ].map((basemapOption) => (
                  <div className="mob_base_gap"
                    key={basemapOption.value}
                    style={{
                      cursor: "pointer",
                      textAlign: "center",
                      width: "80px",
                    }}
                    onClick={() => basemapChange(basemapOption.value)}
                  >
                    <img className="mobasemap"
                      src={basemapOption.img}
                      alt={basemapOption.name}
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        border:
                          basemap === basemapOption.value
                            ? "2px solid #007BFF"
                            : "2px solid #ccc",
                      }}
                    />
                    <small className="mobile_base_font"
                      style={{
                        fontSize: "12px",
                        display: "block",
                        marginTop: "5px",
                      }}
                    >
                      {basemapOption.name}
                    </small>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div>
            <button style={{
              background: '#0d6efd',
              color: 'rgb(255, 255, 255)',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
              position: 'fixed',
              right: '9px',
              bottom: '130px',
              padding: '8px',
              borderRadius: '41px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 2)',
              zIndex: 999,
              width: 'auto'
            }} onClick={handleZoomOut} title="Map Extent" className='mobbase_mapextent'>
              <img
                src={extent}
                alt="Menu Toggle"
                width={32}
                height={32}
              />
            </button>
          </div>

          <div>
            <button style={{
              background: '#0d6efd',
              color: 'rgb(255, 255, 255)',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
              position: 'fixed',
              right: '9px',
              bottom: '65px',
              padding: '8px',
              borderRadius: '41px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 2)',
              zIndex: 999,
              width: 'auto'
            }} onClick={handleClearMap} title="Clear" className='mobbase_clear'>
              <img
                src={clear}
                alt="Menu Toggle"
                width={32}
                height={32}
              />
            </button>
          </div>

          <button
            className="btn btn-primary deskbase mobbase"
            style={{
              position: "fixed",
              bottom: "10px",
              right: "10px",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={handleToggle}
          >
            <span className="material-icons">map</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gis_Dash;